/* istanbul ignore file */
import { createAction } from '@reduxjs/toolkit';
import type { IFetchWebNotificationsRequest, INotificationRequest, IWebNotification } from '../../api/domain';

enum NotificationsApiActions {
    FETCH_WEB_NOTIFICATIONS = 'web.notifications.fetch',
    FETCH_WEB_NOTIFICATIONS_DEBOUNCED = 'web.notifications.fetch.debounced',
    FETCH_WEB_NOTIFICATIONS_SUCCESS = 'web.notifications.fetch.success',
    FETCH_WEB_NOTIFICATIONS_FAILURE = 'web.notifications.fetch.failure',

    SEND_NOTIFICATION = 'notification.send',
    SEND_NOTIFICATION_SUCCESS = 'notification.send.success',
    SEND_NOTIFICATION_FAILURE = 'notification.send.failure',
}

export const fetchWebNotificationsDebounced = createAction<{ request: IFetchWebNotificationsRequest; delayMS: number }>(
    NotificationsApiActions.FETCH_WEB_NOTIFICATIONS_DEBOUNCED,
);
export const fetchWebNotifications = createAction<IFetchWebNotificationsRequest>(NotificationsApiActions.FETCH_WEB_NOTIFICATIONS);
export const fetchWebNotificationsSuccess = createAction<{ notifications: IWebNotification[]; totalCount: number }>(
    NotificationsApiActions.FETCH_WEB_NOTIFICATIONS_SUCCESS,
);
export const fetchWebNotificationsFailure = createAction(NotificationsApiActions.FETCH_WEB_NOTIFICATIONS_FAILURE);

export const sendNotification = createAction<INotificationRequest>(NotificationsApiActions.SEND_NOTIFICATION);
export const sendNotificationSuccess = createAction<string>(NotificationsApiActions.SEND_NOTIFICATION_SUCCESS);
export const sendNotificationFailure = createAction(NotificationsApiActions.SEND_NOTIFICATION_FAILURE);
